import { APP_INITIALIZER, ErrorHandler, NgModule, Provider } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LivepanelErrorHandler } from "./errorHandler/LivepanelErrorHandler";
import { HTTP_INTERCEPTORS, HttpClient } from "@angular/common/http";
import { NotificacionServiceEmisor } from "@shared/services";
import {
    ListaMensajeProcesadorToken,
    providersMensajeProcesador
} from "./errorHandler/logger/transportadores/mensajesProduccionProcesadores";
import {
    ILogger,
    Logger,
    LoggerConfiguracionToken,
    LoggerTransportadorToken,
    MensajeProduccionTransportadorFactory,
    SlackTransportadorFactory
} from "./errorHandler/logger";
import { AuthInterceptor, ErrorHttpInterceptor } from "./interceptors";
import { erroresProviders } from "./erroresParsers/providers";
import { SentryTransportador } from "./errorHandler/logger/transportadores/SentryTransportador";
import * as Sentry from "@sentry/angular-ivy";
import { Router } from "@angular/router";

const transportadoresProviders: Provider[] = [
    {
        provide: LoggerTransportadorToken,
        useFactory: SlackTransportadorFactory,
        multi: true,
        deps: [HttpClient, LoggerConfiguracionToken]
    },
    {
        provide: LoggerTransportadorToken,
        useFactory: MensajeProduccionTransportadorFactory,
        multi: true,
        deps: [NotificacionServiceEmisor, ListaMensajeProcesadorToken]
    },
    {
        provide: LoggerTransportadorToken,
        useClass: SentryTransportador,
        multi: true
    }
];


@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        ...erroresProviders,
        { provide: ErrorHandler, useClass: LivepanelErrorHandler },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorHttpInterceptor, multi: true },
        {
            provide: LoggerConfiguracionToken,
            useValue: {
                transportadores: {
                    consola: true
                }
            }
        },
        ...transportadoresProviders,
        ...providersMensajeProcesador,
        {
            provide: ILogger,
            useClass: Logger
        },
        {
            provide: Sentry.TraceService,
            deps: [Router]
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [Sentry.TraceService],
            multi: true
        }
    ]
})
export class CoreModule { }
